import React from 'react';
import ReactDom from 'react-dom';
import ModalStatus from '@/user/components/fair/modal_status';

const fairModal = document.getElementById('js-fair-modal');
if (fairModal) {
    const startOfMonth = fairModal.dataset.start_month;
    const webReservePeriodDate = fairModal.dataset.web_reserve_period;
    const isCustomFrom = fairModal.dataset.is_custom_form;

    if (! isCustomFrom) {
        ReactDom.render(null, fairModal);
    } else {
        ReactDom.render(
            <>
                <ModalStatus
                    webReservePeriodDate={webReservePeriodDate}
                    startOfMonth={startOfMonth}
                />
            </>,
            fairModal
        );
    }
}
